/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Form controller
 */
export default class extends Controller {
  /**
   * Submit the form.
   */
  submit() {
    this.element.requestSubmit();
  }
}
